import { render, staticRenderFns } from "./CreateOrder.vue?vue&type=template&id=9b0cfbc8&scoped=true&"
import script from "./CreateOrder.vue?vue&type=script&lang=js&"
export * from "./CreateOrder.vue?vue&type=script&lang=js&"
import style0 from "./CreateOrder.vue?vue&type=style&index=0&id=9b0cfbc8&lang=less&scoped=true&"
import style1 from "./CreateOrder.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b0cfbc8",
  null
  
)

export default component.exports